import {
    APP_URL
   ,SET_NAVBAR_ACTIVE
   ,SET_NAV_MENU_OPEN
} from '../constants';

export const initialState = {
    active: APP_URL + "/"
   ,navMenuOpen: false
};

export default (state = initialState, action) => {
    switch (action.type) {
     
        case SET_NAVBAR_ACTIVE:
            return {
                ...state,
                active: action.value
            };
            
        case SET_NAV_MENU_OPEN:
            return {
                ...state,
                navMenuOpen: action.value
            };
            
        default:
            return state;
    }
}
